import React from 'react';
import { twMerge } from 'tailwind-merge';

interface SpinnerProps {
  height?: string;
  width?: string;
  spinningInnerColor?: string;
  borderOuterColor?: string;
  borderSize?: string;
  className?: string;
  centered?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({
  height = 'h-6',
  width = 'w-6',
  spinningInnerColor = 'border-t-gray-100',
  borderOuterColor = 'border-gray-400',
  borderSize = 'border-4',
  className,
  centered,
}) => {
  const spinnerClasses = twMerge(
    borderOuterColor,
    height,
    width,
    centered && 'ml-auto mr-auto',
    borderSize,
    spinningInnerColor,
    'animate-spin rounded-full',
    className,
  );

  return <div className={spinnerClasses} />;
};

export default Spinner;
